import { render } from "./loadingSpinner.vue?vue&type=template&id=ecedb0c6&scoped=true"
const script = {}

import "./loadingSpinner.vue?vue&type=style&index=0&id=ecedb0c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecedb0c6"]])

export default __exports__